<form [formGroup]="parentForm" class="column-layout">
  <div class="select-field-container">
    <div>State</div>
    <select
      class="form-control border border-primary color w-50 h-28"
      [formControlName]="formCtrlName"
      (change)="change()">
      <option value="">Select State</option>
      <option *ngFor="let state of topStates" [value]="state.code">{{ state.name }}</option>
      <optgroup label="──────────"></optgroup>
      <option *ngFor="let state of otherStates" [value]="state.code">{{ state.name }}</option>
    </select>
  </div>
</form>
